import textServices from 'services/text-services'
import { TitleAge } from './style/text'

function ImgAndText() {
  return (
    <section className="flex-1 flex flex-col items-center justify-center bg-cover md:bg-contain bg-no-repeat bg-center gap-3 w-full mb-3">
      <TitleAge className="text-center text-4xl font-bold px-7">
        {textServices.findByText('legalage/title', <>¿Listo para ser parte de un viaje a<br /> QATAR 2022<br /> <span className="text-2xl font-normal">o uno de nuestros 300 kits?</span></>)}
      </TitleAge>
      <img src={`${AZURE_BASE_URL}/agegate.svg`} alt="agegate" className="w-full" />
    </section>
  )
}

export default ImgAndText